import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=544d499a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544d499a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('544d499a')) {
      api.createRecord('544d499a', component.options)
    } else {
      api.reload('544d499a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=544d499a&scoped=true&", function () {
      api.rerender('544d499a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZkCiUwGu0bS4/JS/comp/SearchFilterTokens.vue"
export default component.exports